/*
 *  Licensed under the EUPL, Version 1.2 or – as soon they will be approved by
the European Commission - subsequent versions of the EUPL (the "Licence");
You may not use this work except in compliance with the Licence.
You may obtain a copy of the Licence at:

  https://joinup.ec.europa.eu/software/page/eupl

Unless required by applicable law or agreed to in writing, software
distributed under the Licence is distributed on an "AS IS" basis,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the Licence for the specific language governing permissions and
limitations under the Licence. */

import SvgIcon from "@mui/material/SvgIcon";

const WalkingSurfaceIndicatorsNone = (props) => (
  <SvgIcon
    {...props}
    width="225.000000pt"
    height="225.000000pt"
    viewBox="0 0 20.62 13.58"
    enableBackground="new 0 0 100 100"
    preserveAspectRatio="xMidYMid meet"
  >
    <g id="Layer_1-2" data-name="Layer 1" focusable="false">
      <rect width="20.62" height="13.58" />
    </g>
  </SvgIcon>
);
export default WalkingSurfaceIndicatorsNone;
